import { PROFILE } from '../actionTypes/AccountDetailsActionTypes';

/* istanbul ignore next */
export const getProfile = ({ redirect } = {}) => ({
    type: PROFILE,
    payload: { redirect },
});

export default getProfile;
